var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form',{staticClass:"form profile-name"},[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('ol',[_c('li',[_vm._v("Select Cover")]),_c('li',[_vm._v("Select Matches (All, Fruit, Animals, Vegetables, Icons)")]),_c('li',[_vm._v("Select Size")]),_c('li',[_vm._v("Turn on Sound")])])]),_c('b-col',{attrs:{"cols":"6"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }